export enum 
QueryKey {
    listRoom = 'list-room',
    listRoomDetail = 'list-room-detail',
    mainDetail = 'main-detail',
    mainStatus = 'main-status',
    mainPayment = 'main-payment',
    searchMember = 'search-member',
    informationMember = 'information-member',
    productDailyReport = 'product-daily-report',
    me = 'me',
    category = 'category',
    product = 'item',
    productType = 'item-type',
    productPrice = 'item-price',
    productStore = 'item-store',
    customerType = 'customer-type',
    feeType = 'fee-type',
    coupon = 'coupon',
    store = 'store',
    rank = 'rank',
    customerMobile = 'customer-mobile',
    customerMobileDetail = 'customer-mobile-detail',
    historyUseRoom = 'history-use-room',
    historyCoupon = 'history-coupon',
    historyPoint = 'history-point',
    historyTicket = 'history-ticket',
    historySentMessage = 'history-sent-message',
    listCustomerMobile = 'list-customer-mobile',
    listCustomerMobileWithoutPagination = 'list-customer-mobile-without-pagination',
    ticket = 'ticket',
    issuedTicket = 'issued-ticket',
    usedTicket = 'used-ticket',
    historyUseCoupon = 'history-use-coupon',
    bannerSettings = 'banner-settings',
    visitStoreHistory = 'visit-store-history',
    rankCoupon = 'rank-coupon',
    ticketDetail = 'ticket-detail',
    normalCouponDetail = 'normal-coupon-detail',
    customerMobilesByMobileNos = 'customer-mobiles-by-mobile-nos',
    historyIssuedStamps = 'history-issued-stamps',
    usedTicketByMobileNo = 'used-ticket-by-mobile-no',
    usedTicketUpdate = 'used-ticket-update',
    outTimeBundle = 'out-time-bundle',
    appDownloads = 'app-downloads',
    // remote dashboard
    storesRemote = 'stores-remote',
    callHistory = 'call-history',
    callRecordingFiles = 'call-recording-files',
    periodCallChart = 'period-call-chart',
    timeRangeCallChart = 'time-range-call-chart',
    topStoresChart = 'top-stores-chart',
    appDiscountHistory = 'app-discount-history',
    appDiscountHistoryDetail = 'app-discount-history-detail',
}
